import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create Supabase client with tab-switching optimizations
export const supabase: SupabaseClient<Database> = createClient(
  supabaseUrl, 
  supabaseAnonKey, 
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
      storageKey: 'nexus-booking-auth'
    },
    realtime: {
      // CRITICAL: Disable auto-reconnection on page focus to prevent tab switch reloads
      params: {
        eventsPerSecond: 2,  // Rate limit events
      },
      // Disable automatic reconnection on visibility change
      heartbeatIntervalMs: 30000,   // 30 seconds instead of default 15
      reconnectAfterMs: [1000, 2000, 5000, 10000],  // Slower reconnection
    },
    global: {
      headers: {
        'X-Client-Info': 'nexus-booking-app'
      }
    }
  }
);